import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const SubprogramListPage = () => import('@modules/subprogram/components/subprogram-list-page.vue');
const SubprogramFormPage = () => import('@modules/subprogram/components/subprogram-form-page.vue');
const SubprogramImporterPage = () => import('@modules/subprogram/components/subprogram-importer-page.vue');
const SubprogramViewPage = () => import('@modules/subprogram/components/subprogram-view-page.vue');

// Nba
const SubprogramNbaPage = () => import('@modules/subprogram/nba/components/subprogram-nba-page.vue');
const SubprogramNbaSchoolFormPage = () => import('@modules/subprogram/nba/components/subprogram-nba-school-form-page.vue');
const SubprogramNbaSchoolTeamPage = () => import('@modules/subprogram/nba/components/subprogram-nba-school-team-page.vue');
const SubprogramNbaRoundsFormPage = () => import('@modules/subprogram/nba/components/subprogram-nba-rounds-form.vue');


export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'subprogram',
        path: '/subprogram',
        component: SubprogramListPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramView,
        },
      },
      {
        name: 'subprogramNew',
        path: '/subprogram/new/:manage',
        component: SubprogramFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramCreate,
        },
        props: true,
      },
      {
        name: 'subprogramImporter',
        path: '/subprogram/import',
        component: SubprogramImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramImport,
        },
      },
      {
        name: 'subprogramEdit',
        path: '/subprogram/:id/edit/:manage',
        component: SubprogramFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramEdit,
        },
        props: true,
      },
      {
        name: 'subprogramView',
        path: '/subprogram/:id',
        component: SubprogramViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramView,
        },
        props: true,
      },
      {
        name: 'SubprogramNba',
        path: '/program/:programId/subprogram/:subprogramId/nba/:tabName?',
        component: SubprogramNbaPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramView,
        },
        props: true,
      },
      {
        name: 'SubprogramNbaSchoolTeamNew',
        path: '/program/:programId/subprogram/:subprogramId/team/:teamId/school/new',
        component: SubprogramNbaSchoolFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramView,
        },
        props: true,
      },
      {
        name: 'SubprogramNbaSchoolTeamView',
        path: '/program/:programId/subprogram/:subprogramId/team/:teamId/:tabName',
        component: SubprogramNbaSchoolTeamPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramView,
        },
        props: true,
      },
      {
        name: 'SubprogramNbaSchoolTeamEdit',
        path: '/program/:programId/subprogram/:subprogramId/team/:teamId/school/:schoolId/edit',
        component: SubprogramNbaSchoolFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramEdit,
        },
        props: true,
      },
      {
        name: 'SubprogramRegularSeasonRoundsNew',
        path: '/program/:programId/subprogram/:subprogramId/nba/rounds/new',
        component: SubprogramNbaRoundsFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramCreate,
        },
        props: true,
      },
      {
        name: 'SubprogramRegularSeasonRoundsEdit',
        path: '/program/:programId/subprogram/:subprogramId/nba/rounds/:roundId/edit',
        component: SubprogramNbaRoundsFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.subprogramEdit,
        },
        props: true,
      },
    ],
  },
];
